import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Icon } from '@node-space/ui-components'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { useEarnSheetContext } from '../context/EarnSheetProvider'
import { EARN_SHEET_ACTION_TYPE } from '../types'

export const EarnHeaderActions = () => {
  const { t } = useTranslation()
  const permissions = useMappedRoles()
  const canEditEarn = permissions?.rewards?.canEdit
  const { handleSheetOpen } = useEarnSheetContext()

  const handleOpenDepositSheet = () => {
    handleSheetOpen({ type: EARN_SHEET_ACTION_TYPE.DEPOSIT, header: t('earn.depositSheet.header') })
  }

  const handleOpenWithdrawSheet = () => {
    handleSheetOpen({
      type: EARN_SHEET_ACTION_TYPE.WITHDRAW,
      header: t('earn.withdrawSheet.header'),
    })
  }

  if (!canEditEarn) return null

  return (
    <Box flex gap={12}>
      <Button
        variant="secondary"
        onClick={handleOpenWithdrawSheet}
        iconElement={<Icon name="CoinArrowOutCustom" />}
      >
        {t('earn.withdraw')}
      </Button>
      <Button onClick={handleOpenDepositSheet} iconElement={<Icon name="Plus" />}>
        {t('earn.deposit')}
      </Button>
    </Box>
  )
}
